export default __webpack_public_path__ + "static/media/ISCO CLASS-2 EXAM PATTERN 2025.08865f0b.pdf";